module.exports = __webpack_public_path__ + "static/media/major_family.761af8b1.svg";